export default __webpack_public_path__ + "static/media/image-6.f8da1d9a.jpg";